import "./MobileAuthLink.css";
import { useNavigate } from "react-router-dom";
import { URLS } from "../../constants/constants";

type MobileAuthLinkVariant = "signup" | "login";

const VARIANT_CONFIG: Record<MobileAuthLinkVariant, { wrapperClassName: string; labelText: string; linkText: string; url: string }> = {
  signup: {
    wrapperClassName: "mobileSignUpWrapper",
    labelText: "Don't have an account?",
    linkText: "Sign up",
    url: URLS.SIGN_UP,
  },
  login: {
    wrapperClassName: "mobileLoginWrapper",
    labelText: "Have an account?",
    linkText: "Log in",
    url: URLS.LOGIN,
  },
};

interface MobileAuthLinkProps {
  variant: MobileAuthLinkVariant;
}

const MobileAuthLink = ({ variant }: MobileAuthLinkProps) => {
  const navigate = useNavigate();
  const { wrapperClassName, labelText, linkText, url } = VARIANT_CONFIG[variant];

  return (
    <div className={wrapperClassName}>
      <p className="normal_text black fw-normal m-0 whitespace-nowrap">{labelText}</p>
      <p
        className="normal_text fw-600 blue cursor-pointer m-0 whitespace-nowrap"
        onClick={() => navigate(url)}
      >
        {linkText}
      </p>
    </div>
  );
};

export default MobileAuthLink;
